import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { DonationmaintypeService } from 'src/app/shared/API-Service/services/donationmaintype.service';

@Component({
  selector: 'app-insert-donation-main-type',
  templateUrl: './insert-donation-main-type.component.html',
  styleUrls: ['./insert-donation-main-type.component.css']
})
export class InsertDonationMainTypeComponent implements OnInit {
  recordtoupdate: any;
  donationmaintypeForm : FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _DonationmaintypeService:DonationmaintypeService, private _Router:Router, private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }

  initiate(){
    this.donationmaintypeForm = this._FormBuilder.group({
      title: ['', Validators.required]
    });
  }
  checkEdit() {
    this._DonationmaintypeService.Data.subscribe((res) => {
      if (res != null) {
        this.donationmaintypeForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
        });
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.donationmaintypeForm.status == "VALID"){
  
    this._DonationmaintypeService.CreateDonationMainType(this.donationmaintypeForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationmaintypeForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationmainType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.donationmaintypeForm.status == "VALID"){
    this.donationmaintypeForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._DonationmaintypeService.UpdateDonationMainType(this.donationmaintypeForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationmaintypeForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationmainType']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطا',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.donationmaintypeForm.markAllAsTouched();
    this.button = false;
   }
  }

  get fc() {
    return this.donationmaintypeForm.controls;
  }
  
  ngOnDestroy(){
    this._DonationmaintypeService.Data.next(null);
     }
}
